import React from 'react';
import { Rate, Empty } from "antd";
import utils from 'utils';



export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className='feedback-container' >
        {!this.props?.data[0]?.is_completed ? 
        <div className='chart-noData-card'>
          <Empty description={"No Data"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div> :
          <>
            {(this.props.data || []).map((obj, i) => {
              return (
              
                  <div className="feedback-wrapper-container" key={i}>
                    <div className='feedbacks-card'>
                      <div className='feedback-date'>{utils.FormatDate(obj.appointment_date_time, "DATE_14")}, {utils.FormatDate(obj.appointment_date_time, "TIME_1")}</div>
                      <hr style={{ width: "97%", color: 'grey', opacity: "0.5" }} />
                      {(obj.feedback || []).map((e,j) => {
                        return (
                          e.answer.length > 0 ? <div className='feedbacks' key={j}>
                            <div className='feedback-label'>{e.question.slice(0,-1)}</div>
                            <div>:</div>
                            {e.question.includes("Rating?") ?
                              <div className='feedback-ratings'><Rate count={10} defaultValue={e.answer} disabled={true} /></div>
                              : 
                              <div className='feedback-answers'>{Array.isArray(e.answer) ? e.answer.join(", ") : utils.LineSplit(e.answer)} </div>
                            }
                          </div> : null
                        )
                      })}
                    </div>
                  </div>

              )
            })}
          </>
        }
      </div>
    );
  }
}